// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const SimpleNav = require('client-v2/common/components/simple-nav')
// Entry container imports
const {
  navigateToSearchQueryCollections,
  navigateToSearchQueryInterests,
  navigateToSearchQueryPeople,
  navigateToSearchQueryPosts,
  searchQueryCollectionsHref,
  searchQueryInterestsHref,
  searchQueryPeopleHref,
  searchQueryPostsHref
} = require('../query/actions')

const bemEntity = BemEntity('SearchNav')

function mapStateToProps() {
  const itemsSelector = createItemsSelector()
  return function (state) {
    return {
      bemEntity,
      itemsSelector,
      selectedItemId: selectedState(state),
      query: state.query
    }
  }
}

const mapDispatchToProps = {
  onCollectionsClick: navigateToSearchQueryCollections,
  onInterestsClick: navigateToSearchQueryInterests,
  onPeopleClick: navigateToSearchQueryPeople,
  onPostsClick: navigateToSearchQueryPosts
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    items: stateProps.itemsSelector(stateProps, dispatchProps)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(
  withImmutableToJS(
    SimpleNav
  )
)

// State helpers

function createItemsSelector() {
  return createSelector(
    [
      (stateProps) => stateProps.query,
      (stateProps, dispatchProps) => dispatchProps
    ],
    (query, dispatchProps) => [
      {
        id: 'posts',
        label: `Posts`,
        href: searchQueryPostsHref(query),
        onClick: event => dispatchProps.onPostsClick({ event, query })
      },
      {
        id: 'collections',
        label: `Collections`,
        href: searchQueryCollectionsHref(query),
        onClick: event => dispatchProps.onCollectionsClick({ event, query })
      },
      {
        id: 'people',
        label: `People`,
        href: searchQueryPeopleHref(query),
        onClick: event => dispatchProps.onPeopleClick({ event, query })
      },
      {
        id: 'interests',
        label: `Interests`,
        href: searchQueryInterestsHref(query),
        onClick: event => dispatchProps.onInterestsClick({ event, query })
      }
    ]
  )
}

function selectedState(state) {
  switch (state.router.action) {
    case 'search.showDomainPosts':
      return 'domain'
    case 'search.showQueryCollections':
      return 'collections'
    case 'search.showQueryInterests':
      return 'interests'
    case 'search.showQueryPeople':
      return 'people'
    case 'search.showQueryPosts':
      return 'posts'
    default:
      return null
  }
}
